export default {
  region:'ap-northeast-1',
  queryRequestQueueURL: 'https://sqs.ap-northeast-1.amazonaws.com/777387672724/query-request-queue-prod.fifo',
  transactSqlRequestQueueURL: 'https://sqs.ap-northeast-1.amazonaws.com/777387672724/transact-sql-request-queue-prod.fifo'
}